import { useEffect, useState } from 'react'
import { api, type ScanResponse } from '../api'

export function useScan(params?: Record<string, string>) {
  const [data, setData] = useState<ScanResponse | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const run = async (p?: Record<string, string>) => {
    setLoading(true)
    setError(null)
    try {
      const result = await api.scan(p || params)
      setData(result)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Scan failed')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    run()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(params)])

  return { data, loading, error, run }
}
